/**
 * Utility function providing current css breakpoint value for use in javascript
 * body::before has a content value reflecting current css media query i.e. "xs"
 * refer helpers.less
 *
 * @return {Bool}
 */
const agent = window.navigator ? window.navigator.userAgent : null;
const isIE = agent && (agent.indexOf('MSIE') !== -1 || (navigator && navigator.appVersion.indexOf('Trident/') > -1) || agent.indexOf('Trident/6.0') > -1);

export const getResponsiveTag = () => {
  // if isIE, return desktop everything all the time BECAUSE IE
  if (isIE) {
    return 'lg';
  }

  let tag = window.getComputedStyle(document.body, ':before').getPropertyValue('content');
  tag = tag.split(' ')[0].replace(/"|'/g, '');
  return tag;
};

export const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

export const xs = getResponsiveTag() === 'xs';
export const sm = getResponsiveTag() === 'sm';
export const md = getResponsiveTag() === 'md';
export const lg = getResponsiveTag() === 'lg';
export const xl = getResponsiveTag() === 'xl';
export const xxl = getResponsiveTag() === 'xxl';
export const xxxl = getResponsiveTag() === 'xxxl';
export const xxxxl = getResponsiveTag() === 'xxxxl';

export const mediaMobile = () => getResponsiveTag() === 'xs' || getResponsiveTag() === 'sm';
export const mediaTablet = () => getResponsiveTag() === 'xs' || getResponsiveTag() === 'sm' || getResponsiveTag() === 'md';
export const mediaDesktop = () => getResponsiveTag() === 'lg' || getResponsiveTag() === 'xl' || getResponsiveTag() === 'xxl' || getResponsiveTag() === 'xxxl' || getResponsiveTag() === 'xxxxl';
